<template>
  <div class="mt-8">
    <div v-for="key of Object.keys(score)" :key="key">
      <div v-if="key != 'Reasoning' && key != 'Actual Next Steps'" class="mb-12">
        <dt class="mt-2 text-sm leading-5 font-bold text-gray-800">
          {{ key }}
        </dt>
        <dd class="mt-1 text-sm leading-5 text-gray-900">
          <Progress :progress="score[key]" />
        </dd>
        {{ score.Reasoning[key] }}
      </div>
    </div>
    <div>
      <dt class="mt-4 text-sm leading-5 text-sm leading-5 font-bold text-gray-800">What are the next steps?</dt>
      <dd class="mt-1 leading-5 text-gray-900">
        {{ score['Actual Next Steps'].Recruiter || 'No next steps provided.' }}
      </dd>
    </div>
  </div>
</template>

<script>
import Progress from '../shared/Progress.vue';
export default {
  props: {
    score: {
      type: Object,
      required: true,
    },
  },
  components: {
    Progress,
  },
};
</script>
